module.exports = __webpack_public_path__ + "static/media/business.c322f48a.png";